import { render, staticRenderFns } from "./DiscountCodesAdd.vue?vue&type=template&id=a2674e70&scoped=true"
import script from "./DiscountCodesAdd.vue?vue&type=script&lang=js"
export * from "./DiscountCodesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2674e70",
  null
  
)

export default component.exports